export default __webpack_public_path__ + "media/images/tenant/hero_4-388cf9447ddc0d90f0a334b8ac30e70b.webp";